import Vue from "vue";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { get, isArray, isNil, set } from "lodash";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers("ApplicationStandaloneStore");
export const useApplicationStandaloneStoreActions = useActions;
export const useApplicationStandaloneStoreGetters = useGetters;
export const useApplicationStandaloneStoreMutations = useMutations;
export const useApplicationStandaloneStoreState = useState;
export const splitPath = path => {
  var _split$pop$split$join, _split$pop;
  const split = path.split("[");
  const childPath = (_split$pop$split$join = (_split$pop = split.pop()) == null ? void 0 : _split$pop.split("]").join("")) != null ? _split$pop$split$join : "";
  const parentPath = split.join("[");
  return {
    childPath,
    parentPath
  };
};
const VueSetParentPath = (application, path) => {
  const {
    parentPath,
    childPath
  } = splitPath(path);
  const parentTarget = get(application, parentPath);
  Vue.set(parentTarget, childPath, {});
};
export const VueSetWithPath = (application, path = "", value) => {
  const {
    parentPath,
    childPath
  } = splitPath(path);
  let parentTarget = get(application, parentPath);
  if (parentPath == "") parentTarget = application;
  if (parentTarget == undefined) {
    const {
      parentPath: grandParent,
      childPath: parentPathAlone
    } = splitPath(parentPath);
    let grandParentTarget = get(application, grandParent);
    if (isNil(grandParentTarget)) {
      VueSetParentPath(application, grandParent);
      grandParentTarget = get(application, grandParent);
    }
    Vue.set(grandParentTarget, parentPathAlone, {});
    set(get(application, parentPath), childPath, value);
    return;
  }
  if (isArray(value)) {
    Vue.set(parentTarget, childPath, value);
    return;
  }
  if (/\d/.test(path)) Vue.set(parentTarget, childPath, value);else set(parentTarget, childPath, value);
};